export default {
  1: 'Created',
  2: 'Submitted',
  3: 'Cancelled',
  4: 'Fulfilled',
  5: 'PendingCapturePayment',
  6: 'Future',
  7: 'Paid'
};
